import React from 'react';
import { useFormState } from './useFormState';
import DetailsStep from './Details/ExperienceDetails';
import LocationStep from './Location/ExperienceLocation';
import TrackingStep from './Tracking/ExperienceTracking';
import AmenitiesStep from './Amenities/ExperienceAmenities';
import AvailabilityStep from './Availability/ExperienceAvailability';
import PhotosStep from './Photos/ExperiencePhotos';
import VideosStep from './Videos/ExperienceVideos';
import FloorPlansStep from './FloorPlans/ExperienceFloorPlans';
import GuidesStep from './Guides/ExperienceGuides';
import PoliciesStep from './Policies/ExperiencePolicies';
import PricingStep from './Pricing/ExperiencePricing';
import DiscountsStep from './Discounts/ExperienceDiscounts';
import AccessStep from './Access/ExperienceAccess';
import IntegrationsStep from './Integrations/ExperienceIntegrations';

/**
 * Maps the current step to the corresponding form component
 */
const StepRouter = () => {
    const { step } = useFormState();

    switch (step) {
        case 'details':
            return <DetailsStep />;
        case 'location':
            return <LocationStep />;
        case 'tracking':
            return <TrackingStep />;
        case 'amenities':
            return <AmenitiesStep />;
        case 'availability':
            return <AvailabilityStep />;
        case 'photos':
            return <PhotosStep />;
        case 'videos':
            return <VideosStep />;
        case 'floorplans':
            return <FloorPlansStep />;
        case 'guides':
            return <GuidesStep />;
        case 'policies':
            return <PoliciesStep />;
        case 'pricing':
            return <PricingStep />;
        case 'discounts':
            return <DiscountsStep />;
        case 'access':
            return <AccessStep />;
        case 'integrations':
            return <IntegrationsStep />;
        default:
            return <DetailsStep />;
    }
};

export default StepRouter;
